<template>
    <div class="contact">
        <h1>Contact and location information</h1>
        <p>
            HOURS: TUESDAY &ndash; SATURDAY 11 &ndash; 6<br />
            PHONE: (402)502-8737<br />
            DIRECT EMAIL: INFO@MODERNARTSMIDTOWN.COM
        </p>
        <div class="form-services">
            <div class="form">
                <div class="thanks" v-if="submitted">
                    <h3>Thank you, your message has been sent.</h3>
                </div>
                <div class="loading" v-if="loading">
                    <Loading />
                </div>
            </div>
            <div class="services">
                <h3>Services</h3>
                <ul>
                    <li>Presentation and Planning Services</li>
                    <li>Residential and Commercial Projects</li>
                    <li>Delivery and Installation</li>
                    <li>Packing and Shipping</li>
                    <li>Art Consultation</li>
                </ul>
                <div class="location">
                    Location: 3615 Dodge St, Omaha, NE 68131
                </div>
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2999.2735679847733!2d-95.9695543845782!3d41.259379079276115!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x87938e6ed4dce039%3A0xd7a225cb9ce47d8f!2sModern%20Arts%20Midtown!5e0!3m2!1sen!2sus!4v1645281136731!5m2!1sen!2sus" width="500" height="250" style="border:0;" allowfullscreen="" loading="lazy"></iframe>
            </div>
        </div>
    </div>
</template>

<script>
import ArtworkHelper from "@/mixins/PageHelper.js";
import { API_URI } from "@/helpers/config";

const formUrl = API_URI + "/contact_api";
//const formUrl = 'https://modernartsmidtown-local.dev.dynamic.ms/contact';

const getContactForm = (function _getContactForm() {
    var promise;
    return function getContactForm() {
        // or grab #center and remove #pageTitle
        promise =
            promise ||
            fetch(formUrl)
                .then((response) => response.text())
                .then((html) =>
                    new DOMParser().parseFromString(html, "text/html")
                )
                .then((doc) => doc.querySelector("#center"))
                .then((el) => {
                    const form = el.querySelector("#contact-mail-page")
                    if (form) form.action = formUrl;
                    return el;
                });
        return promise;
    };
})();

export default {
    name: "Home",
    mixins: [ArtworkHelper],
    data() {
        return {
            loading: true,
            submitted: false
        };
    },
    computed: {
        documentTitle() {
            return "Contact | " + this.documentTitleBase;
        },
    },
    created() {
        // todo mounted?
        const vm = this;
        getContactForm().then((form) => {
            vm.$el.querySelector(".form").append(form);
            const formEl = vm.$el.querySelector(".form form");
            if (! formEl) {
                vm.loading = false;
                return false;
            }
            vm.attachRecaptcha()

            if (vm.$route.query.artwork) {
                const nids = vm.$route.query.artwork.split(',').map(n => +n);
                const artworks = vm.allArtworks.filter(a => nids.includes(+a.nid));
                const message = `I am interested in:\n`
                        + artworks.map(artwork => `"${artwork.title} (${artwork.nid})" by ${artwork.artist.name}`).join("\n")
                        + "\n\n"
                        + vm.favoritesPermaLink(nids);

                vm.$el.querySelector("#edit-message").value = message;
            }

            if (formEl._submitBound) {
                formEl.removeEventListener('submit', formEl._submitBound)
            }
            formEl._submitBound = (event) => vm.submit(event)
            formEl.addEventListener('submit', formEl._submitBound)
            vm.loading = false;
        });
    },
    methods: {
        attachRecaptcha() {
            const vm = this
            const captchaEl = vm.$el.querySelector(".g-recaptcha");
            if (captchaEl && !captchaEl.dataset["recaptchaRendered"]) {
                captchaEl.dataset["recaptchaRendered"] = true;
                window.grecaptcha.render(captchaEl, {
                    sitekey: captchaEl.dataset.sitekey,
                });
            }
        },
        submit(event) {
            const vm = this

            event.preventDefault();
            //const captchaValidated = window.grecaptcha.getResponse().length > 0

            const formData = new FormData(event.target)
            //const data = Object.fromEntries(formData.entries())
            const data = new URLSearchParams(formData);

            const url = event.target.action

            fetch(url, {
                method: 'POST', // *GET, POST, PUT, DELETE, etc.
                //mode: 'cors', // no-cors, *cors, same-origin
                mode: 'cors', // no-cors, *cors, same-origin
                cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
                credentials: 'omit', // include, *same-origin, omit
                headers: {
                // 'Content-Type': 'application/json'
                  'Content-Type': 'application/x-www-form-urlencoded',
                //    "Content-Type": "multipart/form-data",
                },
                //redirect: 'follow', // manual, *follow, error
                redirect: 'manual', // manual, *follow, error
                referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
                // body: JSON.stringify(data) // body data type must match "Content-Type" header
                body: data
            })
            .then(response => {
                if (response.type == 'opaqueredirect') {
                    // if we were redirected then post succeeded
                    const form = vm.$el.querySelector(".form")
                    form.querySelector("#center").remove()
                    vm.submitted = true
                } else {
                    response.text()
                    .then(html => new DOMParser().parseFromString(html, "text/html"))
                    .then(doc => doc.querySelector("#center"))
                    .then(el => {
                        const form = vm.$el.querySelector(".form")
                        form.querySelector("#center").remove()
                        form.append(el)
                        form.querySelector("#contact-mail-page").action = formUrl
                        vm.attachRecaptcha()
                        vm.$el.querySelector(".form form").addEventListener('submit', (event) => vm.submit(event))
                    })
                }
            })
        },
    }
};
</script>

<style lang="scss">
</style>
